import { useState } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Box, Typography, Button, TextField } from '@mui/material';
import { loadFavicon, resetFavicon } from '../utils/Favicon';
import { REST_API_BASE_URL, getInitialCriteria, encryption, getIv } from '../utils/utils';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordCriteria, setPasswordCriteria] = useState(getInitialCriteria());
    const email = localStorage.getItem("email");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [iv,  setIv] = useState(getIv());
    const token = useSelector(state => state.auth.token);


    function validatePassword(password) {
        for(const c of password) {
            if(c >= 'a' && c <= 'z') {
                passwordCriteria.lowerCase++;
                setPasswordCriteria(passwordCriteria)
            } else if(c >= 'A' && c <= 'Z') {
                passwordCriteria.upperCase++;
                setPasswordCriteria(passwordCriteria);
            } else if(c >= '0' && c <= '9') {
                passwordCriteria.numeric++;
                setPasswordCriteria(passwordCriteria);
            } else {
                passwordCriteria.specialCharacter++;
                setPasswordCriteria(passwordCriteria);
            }

            passwordCriteria.length++;
            setPasswordCriteria(passwordCriteria);
        }

        console.log(passwordCriteria);
        
        let result = passwordCriteria.upperCase > 0 
        result = result && passwordCriteria.lowerCase > 0 
        result = result && passwordCriteria.numeric > 0
        result = result && passwordCriteria.specialCharacter > 0
        result = result && passwordCriteria.length > 8

        setPasswordCriteria(getInitialCriteria());
        return result;
    }

    function matchPassword() {
        let result = true;

        if(newPassword.length !== confirmPassword.length) {
            result = false;
        } else {
            for(var i=0; i<newPassword.length && i<confirmPassword.length; i++) {
                if(newPassword[i] !== confirmPassword[i]) {
                    result = false;
                    break;
                }
            }
        }

        return result;
    }

    function getHeaders() {
        if(token) {
            return {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token['accessToken']}`,
                'ApiKey': `${token['secret']}`
            }
        } else {
            return {
                'Content-Type': 'application/json'
            }
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;

        if(name === "newPassword") {
            setNewPassword(value);
        } else if(name === "confirmPassword") {
            setConfirmPassword(value);
        } else {
            setCurrentPassword(value);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!validatePassword(confirmPassword)) {
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setErrorMessage("Password did not fulfill the criteria.");
            setError(true);
        } else if(!matchPassword()) {
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setErrorMessage("Password did not match.");
            setError(true);
        } else {
            let data;

            if(!token) {
                const token = searchParams.get("token");
                const splitedToken = token.split("|");

                data = {
                    guid: splitedToken[0],
                    userId: splitedToken[1],
                    newPassword: encryption(confirmPassword, iv),
                    iv: iv.toString(CryptoJS.enc.Base64)
                }
            } else {
                data = {
                    currentPassword: encryption(currentPassword, iv),
                    newPassword: encryption(confirmPassword, iv),
                    iv: iv.toString(CryptoJS.enc.Base64)
                }
            }

            loadFavicon();
            try {
                // let response;

                // if(!token) {
                //     response = await axios.post(
                //         REST_API_BASE_URL + 'resetPassword', 
                //         data, 
                //         {
                //             headers: {
                //                 'Content-Type': 'application/json'
                //             },
                //         }
                //     );
                // } else {
                //     response = await wrapperCall('changePassword', data, token, 'json');           
                // }
                const endpoint = (token)? 'changePassword' : 'resetPassword';

                const response = await axios.post(
                    REST_API_BASE_URL + endpoint, 
                    data, 
                    {
                        headers: getHeaders()
                    }
                );
        
                console.log(response.data);
                setError(false);
                setSuccess(true);
            } catch(error) {
                // console.error("Error submitting form:", error);
                console.log("Status code: " + error["status"]);
                console.log(error);
                switch(error.status) {
                    case 406:
                        setErrorMessage("Last 10 recently used password cannot be used.");
                        break;
                    
                    case 400:
                        setErrorMessage("Request is not valid.");
                        break;

                    case 500:
                        setErrorMessage("Server-side error, kindly try again later");
                        break;

                    case 405:
                        setErrorMessage("Incorrect current password.");
                        break;
                }
                setError(true);
            } finally {
                resetFavicon();
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
                // localStorage.clear();
            }
        }
    };

    return(
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "50px",
                gap: "20px",
            }}
        >
            {success? <Navigate to={"/login"} />  :
            <Box sx={{ width: "40%" }}>
                <Typography variant="h5" sx={{ color: "text.primary" }}>
                    Password Reset
                </Typography>
                <Typography variant="subtitle1" color="text.primary">
                    Password must satisfy the following criteria:
                </Typography>

                <Box sx={{ marginTop: "10px", marginLeft: "10px" }}>
                    <Typography variant="body2" color="text.secondary">
                        • Must be at least 9 characters long
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must contain at least 1 uppercase letter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must contain at least 1 lowercase letter
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must include at least 1 numeric character
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Must have at least 1 special character
                    </Typography>
                </Box>

                {error && <Box sx={{ marginTop: "10px", marginLeft: "10px" }}> 
                    <Typography variant="subtitle1" color="error">
                        {errorMessage}
                    </Typography>
                </Box> }
            </Box>}

            <Box
                component="form"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40%",
                    gap: "15px",
                }}
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit}
            >
                <Box sx={{ width: "100%" }}>
                    <TextField
                        id={!token? "email" : "currentPassword"}
                        label={!token? "Email" : "Current Password"}
                        name={!token? "email" : "currentPassword"}
                        type={!token? "text" : "password"}
                        value={!token? email : currentPassword}
                        variant="standard"
                        sx={{ width: "100%" }}
                        disabled={!token}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="newPassword"
                        label="New Password"
                        name="newPassword"
                        type="password"
                        value={newPassword}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%" }}>
                    <TextField
                        id="confirmPassword"
                        label="Confirm Password"
                        name="confirmPassword"
                        type="password"
                        value={confirmPassword}
                        variant="standard"
                        sx={{ width: "100%" }}
                        onChange={handleChange}
                    />
                </Box>

                <Box sx={{ width: "100%", textAlign: "center", marginTop: "15px" }}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            width: "40%",
                            color: "white",
                            backgroundColor: "red",
                            "&:hover": { backgroundColor: "#8b0000" },
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default ResetPassword;